export default __webpack_public_path__ + "static/media/archive.f18c2cc9.svg";